import { z } from "zod";

export const quizResponsePayloadSchema = z.discriminatedUnion("format", [
	z.object({
		format: z.literal("MULTIPLE_CHOICE_SINGLE"),
		selectedAnswerId: z.string().min(1),
	}),
	z.object({
		format: z.literal("MULTIPLE_CHOICE_MULTI"),
		selectedAnswerIds: z.array(z.string().min(1)),
	}),
	z.object({
		format: z.literal("FILL_IN_BLANK"),
		blankValues: z.array(z.string()),
	}),
	z.object({
		format: z.literal("TYPE_ANSWER"),
		text: z.string(),
	}),
	z.object({
		format: z.literal("WORD_REORDER"),
		orderedAnswerIds: z.array(z.string().min(1)),
	}),
	z.object({
		format: z.literal("RANK_ORDER"),
		orderedAnswerIds: z.array(z.string().min(1)),
	}),
	z.object({
		format: z.literal("PAIR_MATCHING"),
		pairs: z.array(
			z.object({
				leftId: z.string().min(1),
				rightId: z.string().min(1),
			}),
		),
	}),
]);

export type QuizResponsePayload = z.infer<typeof quizResponsePayloadSchema>;

export function parseQuizResponsePayload(
	data: unknown,
): QuizResponsePayload | null {
	const parsed = quizResponsePayloadSchema.safeParse(data);
	return parsed.success ? parsed.data : null;
}
